import {
  SHOW_GIFT_CARD_MODAL,
  INITIATE_ADD_GIFT_CARD,
  RESET_GIFT_CARD_REDUCER,
  INITIATE_CONNECTING_EXISTING_GIFT_CARD,
  INITIATE_RELOAD_GIFT_CARD,
  RELOAD_GIFT_CARD,
  SHOW_CONFIRM_DELETE_MODAL_GIFT_CARD,
  HIDE_CONFIRM_DELETE_MODAL_GIFT_CARD,
} from './giftCardTypes';
import api from '../../api';
import { getPaymentMethods } from '../PaymentMethods/paymentMethodsActions';
import { createAlert } from '../Alert/alertActions';
import formatedBEErrorMessage from '../../utils/formatedBEErrorMessage';
import { getLoyalty } from '../Loyalty/loyaltyActions';

export function clearGiftCardErrorMessage() {
  return function(dispatch) {
    dispatch({
      type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
      errors: {},
    });
  };
}
export function showGiftCardModal(boolean) {
  return function(dispatch) {
    dispatch({ type: SHOW_GIFT_CARD_MODAL, boolean });
  };
}

export function initiateAddNewGiftCard() {
  return function(dispatch) {
    dispatch({ type: INITIATE_ADD_GIFT_CARD });
  };
}

export function resetGiftCardReducer() {
  return function(dispatch) {
    dispatch({ type: RESET_GIFT_CARD_REDUCER });
  };
}

export function initiateConnectExistingGiftCard() {
  return function(dispatch) {
    dispatch({ type: INITIATE_CONNECTING_EXISTING_GIFT_CARD });
  };
}

export function connectExistingGiftCard(values) {
  let details = {
    card_number: values.giftCardNumber
      .split(' ')
      .join('')
      .toString(),
  };
  if (values.pin) {
    details['pin'] = values.pin;
  }
  const payload = {
    type: 'gift_card',
    details,
  };

  return function(dispatch, getState) {
    dispatch({
      type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
      errors: {},
    });
    api
      .post('/payment-methods', payload, {
        ignore_interception: true,
      })
      .then((response) => {
        dispatch(getPaymentMethods());
        dispatch(
          createAlert({
            type: 'success',
            message: 'Gift card connected successfully',
          })
        );
        dispatch(resetGiftCardReducer());
      })
      .catch((error) => {
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
          errors: errors,
        });
      });
  };
}

export function addFunds(values) {
  const { fundAmt } = values;
  const payload = {
    amount: parseFloat(fundAmt),
  };
  if (values?.cvv) {
    payload['cvv'] = values.cvv;
  }
  return function(dispatch, getState) {
    dispatch({
      type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
      errors: {},
    });
    api
      .post('/gift-cards/buy', payload, {
        ignore_interception: true,
      })
      .then((response) => {
        dispatch(getPaymentMethods());
        dispatch(
          createAlert({
            type: 'success',
            message: 'Gift card purchased successfully',
          })
        );
        dispatch(resetGiftCardReducer());
      })
      .catch((error) => {
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
          errors: errors,
        });
      });
  };
}

export function initiateReloadGiftCard(boolean) {
  return function(dispatch) {
    dispatch({ type: INITIATE_RELOAD_GIFT_CARD, boolean });
  };
}

export function reloadGiftCard(giftCardDetails) {
  return function(dispatch) {
    dispatch({ type: RELOAD_GIFT_CARD, giftCardDetails });
  };
}

export function reloadFunds(values) {
  const payload = {
    amount: parseFloat(values.fundAmt),
    reload_payment_method_id: values.giftCardDetails.id,
  };
  if (values?.cvv) {
    payload['cvv'] = values.cvv;
  }
  return function(dispatch, getState) {
    dispatch({
      type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
      errors: {},
    });
    api
      .post(`/gift-cards/reload`, payload, {
        ignore_interception: true,
      })
      .then((response) => {
        dispatch(getPaymentMethods());
        dispatch(
          createAlert({
            type: 'success',
            message: 'Gift card reloaded successfully',
          })
        );
        dispatch(resetGiftCardReducer());
        dispatch(getLoyalty());
      })
      .catch((error) => {
        const errors = formatedBEErrorMessage(error);
        dispatch({
          type: 'UPDATE_GIFTCARD_ERROR_MESSAGE',
          errors: errors,
        });
      });
  };
}

export function removeGiftCard(giftCardId) {
  return function(dispatch) {
    return api.delete(`/payment-methods/${giftCardId}`).then(
      (response) => {
        dispatch(getPaymentMethods());
        dispatch(resetGiftCardReducer());
        dispatch(
          createAlert({
            type: 'success',
            message: 'Gift card removed successfully',
          })
        );
        dispatch(hideConfirmDeleteModal());
      },
      (error) => {
        dispatch(
          createAlert({
            type: 'error',
            message: 'Sorry, an error occurred trying to delete the gift card',
          })
        );
      }
    );
  };
}

export function showConfirmDeleteModal() {
  return {
    type: SHOW_CONFIRM_DELETE_MODAL_GIFT_CARD,
  };
}

export function hideConfirmDeleteModal() {
  return {
    type: HIDE_CONFIRM_DELETE_MODAL_GIFT_CARD,
  };
}

export function displayReloadGiftCard(paymentMethod) {
  return function(dispatch, getState) {
    const onlyGiftCard = getState().paymentMethodsReducer.paymentMethods.find(
      (method) => method.type === 'gift_card'
    );
    dispatch(showGiftCardModal(true));
    dispatch(initiateReloadGiftCard(true));
    dispatch(reloadGiftCard(paymentMethod ?? onlyGiftCard));
  };
}
